module.exports = __webpack_public_path__ + "img/logo-f1.62184601.png";